import { instance } from '@/api/instances'

const fetchCurrentHealthActions = async (store, appointmentId) => {
  try {
    const actions = await instance.get(`actions/appointment/${appointmentId}`)

    store.commit('setCurrentHealthActions', actions)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'appointment/fetchCurrentHealthActions' },
      { root: true }
    )
  }
}

const saveCurrentHealthActions = async (
  store,
  { healthActions, additionalFupMessage }
) => {
  try {
    const actionsList = healthActions.flatMap(
      actionsGroup => actionsGroup.actions
    )
    const executeActions = actionsList.filter(a => a.checked)

    const payload = {
      originEvent: { ...healthActions[0].originEvent },
      originalActions: actionsList.map(a => {
        // eslint-disable-next-line no-unused-vars
        const { ...obj } = a
        return obj
      }),
      executeActions: executeActions.map(a => {
        // eslint-disable-next-line no-unused-vars
        const { ...obj } = a
        return {
          ...obj,
          additionalFupMessage: obj.autoExec ? additionalFupMessage[obj.id] : ''
        }
      })
    }
    await instance.post('actions/apply', { json: payload })
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'appointment/saveCurrentHealthActions' },
      { root: true }
    )
  }
}

const createCounterReferral = async (_, counterReferral) => {
  try {
    const result = await instance.post('counter_referrals', {
      json: counterReferral
    })

    return { ...result, error: false }
  } catch (error) {
    return { error: true }
  }
}

export default {
  fetchCurrentHealthActions,
  saveCurrentHealthActions,
  createCounterReferral
}
